const { host } = window.location

const API_HOST = () => {
  if (host.includes('chat.people.com.ai')) {
    return 'https://api.people.com.ai'
  }

  if (host.includes('localhost')) {
    return 'https://api.dev.people'
  }

  return `https://api${host.substr(host.indexOf('.'))}`
}

const SERVICE_EVENTHUB = '/eventhub/webchat'
const MINUTES_TO_RESET_CACHE_LASTMESSAGE = 60
const MINUTES_TO_RESET_CACHE_CREATEDAT = 1440
const SERVICE_CHANNEL = `${API_HOST()}/channel/api`

export default {
  API_HOST,
  SERVICE_EVENTHUB,
  SERVICE_CHANNEL,
  MINUTES_TO_RESET_CACHE_LASTMESSAGE,
  MINUTES_TO_RESET_CACHE_CREATEDAT
}
